module.exports = __webpack_public_path__ + "static/media/OYO.94935abe.jpg";